export const bonus_round_dialogue = (t) => ({
	BONUS_ROUND_DIALOGUE_HEADER: {
		value: 'CONGRATULATIONS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 70,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ROUND_FINISHED_HEADER: {
		value: 'CONGRATULATIONS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 70,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ROUND_FINISHED_TEXT: {
		value: t('bonus.you_have_won'),
		config: {
			fill: '#EED999',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	BONUS_ROUND_FINISHED_WINAMOUNT: {
		value: '$0.00',
		config: {
			lineHeight: 1,
			fontFamily: 'Japanese',
			fontSize: 100,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ROUND_FINISHED_TOTAL: {
		value: 'TOTAL',
		config: {
			fontFamily: 'Japanese',
			fontSize: 70,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ROUND_FINISHED_NOTE: {
		value: t('bonus.press_to_continue'),
		config: {
			fill: '#EED999',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	BONUS_ROUND_DIALOGUE_TEXT_1: {
		value: t('bonus.you_have_got'),
		config: {
			fill: '#EED999',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	BONUS_ROUND_DIALOGUE_TEXT_2: {
		value: '13 BONUS SPINS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 105,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_ROUND_DIALOGUE_TEXT_3: {
		value: t('bonus.press_to_start'),
		config: {
			fill: '#EED999',
			fontFamily: 'Poppins SemiBold',
			fontSize: 24
		}
	},
	BONUS_ROUND_DIALOGUE_TEXT_4: {
		value: t('bonus.catch_special_crystal'),
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 20,
			align: 'center'
		}
	}
});
